export default "/build/images/2head.png?9a01911ce252c1b88fbab45ede130eff";